import config from "@Config/index";
import { logAppEvent } from "@Utils/appAnalytics";
import { APP_EVENTS } from "@Utils/webApputils/analyticEvents";
import axios from "axios";
import getCookie from "helpers/getCookie";

const saveStepwiseData = async ({ data, isPaymentBeforeBookform = false, stepName }: any) => {
  try {
    await axios.post(
      `${config.API_URL}/api/v0/partial_forms`,
      {
        partial_forms: {
          ...data,
          meta: {
            payment_before_bookform: Boolean(isPaymentBeforeBookform),
          },
          source: "internal",
          step: stepName,
        },
      },
      {
        withCredentials: true,
      },
    );
    logAppEvent({
      eventName: APP_EVENTS.PARTIAL_BOOKFORM_SUBMITTED,
      payload: {
        property_id: data?.inventory_id,
        room_name: data?.roomType,
        tenancy_name: data?.tenancyId,
        user_name: data["user_details/name"],
        user_email: data["user_details/email"],
        user_phone: `${data["user_details/phone_code"]} ${data["user_details/phone"]}`,
        step: stepName,
      },
    });
  } catch (error) {
    if (typeof window !== undefined && typeof window.Sentry !== "undefined") {
      window.Sentry.captureException(`Partial form save data error for ${stepName} -> ${error}`, {
        extra: {
          user_token: getCookie("user_flow_token"),
          payload: JSON.stringify({
            partial_forms: {
              ...data,
              meta: {
                payment_before_bookform: Boolean(isPaymentBeforeBookform),
              },
              source: "internal",
              step: stepName,
            },
          }),
        },
      });
    }
  }
};

export default saveStepwiseData;
